<template>
    <v-text-field
        solo
        hide-details
        clearable
        label="Search"
        prepend-inner-icon="mdi-magnify"
        v-bind:value="value"
        v-on:input="$emit('input', $event)"
    ></v-text-field>
</template>

<script>
export default {
    props: {
        value: String
    }
};
</script>
